import React, {useMemo} from 'react';
import {View, FlatList, StyleSheet} from 'react-native';
import ShortcutButton from 'src/components/elements/home/ShortcutButton';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import Localized from 'src/constants/AppStrings';

export enum ShortcutType {
  Dining = 'Dining',
  Vending = 'Vending',
  ScanProduct = 'ScanProduct',
  Wallet = 'Wallet',
  Pay = 'Pay',
}

export type ShortCutItem = {
  type: ShortcutType;
  title: string;
  isAvailable: boolean;
  locations?: CampusLocationType[];
};

type ShortcutBarProps = {
  dining: Array<CampusLocationType>;
  scanAndPay: Array<CampusLocationType>;
  vending: Array<CampusLocationType>;
  onDiningClick?: (
    machine: CampusLocationType,
    autoAdvanced?: boolean,
  ) => Promise<void>;
  onScanAndPayClick?: (locations: CampusLocationType[]) => void;
  onVendingClick?: (locations: CampusLocationType[]) => void;
};

const ShortcutBar = (props: ShortcutBarProps) => {
  const shortcutsList: ShortCutItem[] = useMemo(
    () => [
      {
        type: ShortcutType.Wallet,
        title: Localized.Labels.wallet,
        isAvailable: true,
      },
      {
        type: ShortcutType.Dining,
        title: Localized.Labels.dining,
        isAvailable: props.dining?.length > 0,
        locations: props.dining,
      },
      {
        type: ShortcutType.Vending,
        title: Localized.Labels.vending,
        isAvailable: props.vending?.length > 0,
        locations: props.vending,
      },
      {
        type: ShortcutType.ScanProduct,
        title: Localized.Labels.product,
        isAvailable: props.scanAndPay?.length > 0,
        locations: props.scanAndPay,
      },
      {
        type: ShortcutType.Pay,
        title: Localized.Labels.pay,
        isAvailable: Settings.isRefiveAnd365PayOnly(),
      },
    ],
    [props.dining, props.vending, props.scanAndPay],
  );

  const shortcutItems = shortcutsList.filter((item) => item.isAvailable);

  const renderItem = ({item}) => (
    <ShortcutButton
      shortcut={item}
      onDiningClick={props.onDiningClick}
      onScanAndPayClick={props.onScanAndPayClick}
      onVendingClick={props.onVendingClick}
    />
  );

  const keyExtractor = React.useCallback(
    (shortcut: ShortCutItem) => shortcut.type,
    [],
  );

  return (
    <View style={styles.container}>
      <FlatList
        renderItem={renderItem}
        horizontal={true}
        data={shortcutItems}
        showsHorizontalScrollIndicator={false}
        ListFooterComponent={() => <View style={styles.footerView} />}
        keyExtractor={(item: ShortCutItem) => keyExtractor(item)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: Styles.Spacing.m3,
  },
  footerView: {
    width: Styles.Spacing.m3,
  },
});

export default ShortcutBar;
